import { useQuery } from '@tanstack/react-query';
import { baseUrl } from '../utils/url';

const useUser = () => {
  const { token } = JSON.parse(localStorage.getItem('user')) || {};
  const {
    isLoading,
    error,
    data: user,
    refetch,
  } = useQuery({
    queryKey: ['user'],
    queryFn: () =>
      fetch(`${baseUrl}verify`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => res.json()),
  });

  return [user, isLoading, error, refetch];
};

export default useUser;
